export default __webpack_public_path__ + "static/media/youtube.50aff43e.webp";